import React from 'react';
import { motion } from 'framer-motion';
const stack = [{
  emoji: '📖',
  name: 'The Complete Back To You Method',
  desc: 'The full 90-day postpartum restoration system — body, identity, and energy'
}, {
  emoji: '🏋️',
  name: 'The 12-Minute Metabolic Burst Protocol',
  desc: 'Daily activation sequences — no gym, no equipment, full results'
}, {
  emoji: '🍽️',
  name: 'The Holy Plate Nutrition System',
  desc: "Pro-hormonal eating that works whether you're nursing or not"
}, {
  emoji: '🧠',
  name: 'The Identity Ritual Guide',
  desc: 'Daily 2-minute morning practice to reclaim your sense of self'
}, {
  emoji: '😴',
  name: 'Broken Sleep Optimization Protocol',
  desc: 'Supplementation + environment guide to maximize recovery on minimal sleep'
}, {
  emoji: '🗓️',
  name: 'Complete 30-Day Action Plan',
  desc: 'Day-by-day map — you always know exactly what to do'
}, {
  emoji: '🔧',
  name: 'Diastasis Self-Check & Repair Guide',
  desc: 'Identify your level of separation and follow the exact repair sequence'
}];
export function OfferStack() {
  return <section className="bg-white px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-127">
      <div className="mx-auto max-w-4xl" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-10" data-id="element-129">
          <h2 className="mb-4 font-serif text-4xl font-bold text-[#2D2D2D] sm:text-5xl" data-id="element-130">
            When you get Back To You, here's what you receive:
          </h2>
        </motion.div>

        <div className="rounded-3xl bg-[#FBF7F0] p-8 sm:p-12 shadow-xl border border-[#D4603A]/10" data-id="element-131">
          <div className="space-y-6" data-id="element-132">
            {stack.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4 border-b border-[#2D2D2D]/10 pb-6 last:border-0 last:pb-0" data-id="element-133">
                <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-white text-2xl shadow-sm" data-id="element-134">
                  {item.emoji}
                </div>
                <div data-id="element-135">
                  <h3 className="mb-1 font-serif text-xl font-bold text-[#2D2D2D]" data-id="element-136">
                    {item.name}
                  </h3>
                  <p className="font-sans text-[#2D2D2D]/80" data-id="element-137">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}